import { PaymentIntegrationSelectors } from '@bigcommerce/checkout-sdk/payment-integration-api';

import { InternalCheckoutSelectors } from '../checkout';
import { cloneResult as clone } from '../common/utility';

export default function createPaymentIntegrationSelectors({
    billingAddress: { getBillingAddress, getBillingAddressOrThrow },
    cart: { getCart, getCartOrThrow, getLocale: getCartLocale },
    checkout: { getCheckout, getCheckoutOrThrow, getOutstandingBalance },
    config: {
        getContextConfig,
        getHost,
        getLocale,
        getStoreConfig,
        getStoreConfigOrThrow,
        getConfig,
    },
    consignments: { getConsignments, getConsignmentsOrThrow },
    countries: { getCountries },
    customer: { getCustomer, getCustomerOrThrow },
    instruments: {
        getCardInstrument,
        getCardInstrumentOrThrow,
        getInstruments,
        getInstrumentsMeta,
    },
    order: { getOrder, getOrderOrThrow, getOrderMeta },
    payment: {
        getPaymentToken,
        getPaymentTokenOrThrow,
        getPaymentId,
        getPaymentIdOrThrow,
        getPaymentStatus,
        getPaymentStatusOrThrow,
        getPaymentRedirectUrl,
        getPaymentRedirectUrlOrThrow,
        isPaymentDataRequired,
    },
    paymentMethods: { getPaymentMethod, getPaymentMethodOrThrow, getPaymentMethodsMeta },
    paymentProviderCustomer: { getPaymentProviderCustomer, getPaymentProviderCustomerOrThrow },
    paymentStrategies: { isInitialized: isPaymentMethodInitialized },
    shippingAddress: {
        getShippingAddress,
        getShippingAddressOrThrow,
        getShippingAddresses,
        getShippingAddressesOrThrow,
    },
    shippingCountries: { getShippingCountries },
}: InternalCheckoutSelectors): PaymentIntegrationSelectors {
    return {
        getHost: clone(getHost),
        getLocale: clone(getLocale),
        getCartLocale: clone(getCartLocale),
        getBillingAddress: clone(getBillingAddress),
        getBillingAddressOrThrow: clone(getBillingAddressOrThrow),
        getCart: clone(getCart),
        getCartOrThrow: clone(getCartOrThrow),
        getCheckout: clone(getCheckout),
        getCheckoutOrThrow: clone(getCheckoutOrThrow),
        getCountries: clone(getCountries),
        getStoreConfig: clone(getStoreConfig),
        getStoreConfigOrThrow: clone(getStoreConfigOrThrow),
        getConfig: clone(getConfig),
        getConsignments: clone(getConsignments),
        getConsignmentsOrThrow: clone(getConsignmentsOrThrow),
        getContextConfig: clone(getContextConfig),
        getCustomer: clone(getCustomer),
        getCustomerOrThrow: clone(getCustomerOrThrow),
        getCardInstrument: clone(getCardInstrument),
        getInstruments: clone(getInstruments),
        getCardInstrumentOrThrow: clone(getCardInstrumentOrThrow),
        getOrder: clone(getOrder),
        getOrderOrThrow: clone(getOrderOrThrow),
        getOrderMeta: clone(getOrderMeta),
        getInstrumentsMeta: clone(getInstrumentsMeta),
        getPaymentToken,
        getPaymentTokenOrThrow,
        getPaymentId,
        getPaymentIdOrThrow,
        getPaymentStatus,
        getPaymentStatusOrThrow,
        getPaymentRedirectUrl,
        getPaymentRedirectUrlOrThrow,
        getPaymentMethod: clone(getPaymentMethod),
        getPaymentMethodOrThrow: clone(getPaymentMethodOrThrow),
        getPaymentMethodsMeta: clone(getPaymentMethodsMeta),
        getPaymentProviderCustomer: clone(getPaymentProviderCustomer),
        getPaymentProviderCustomerOrThrow: clone(getPaymentProviderCustomerOrThrow),
        getShippingAddress: clone(getShippingAddress),
        getShippingAddressOrThrow: clone(getShippingAddressOrThrow),
        getShippingAddresses: clone(getShippingAddresses),
        getShippingAddressesOrThrow: clone(getShippingAddressesOrThrow),
        getShippingCountries: clone(getShippingCountries),
        getOutstandingBalance: clone(getOutstandingBalance),
        isPaymentDataRequired,
        isPaymentMethodInitialized,
    };
}
